var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-tooltip`, `${_vm.$appPrefix}-tooltip--${_vm.theme}`, _vm.visibleClass, _vm.positionClass],style:({width: _vm.width})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }